import SettingsBackupRestoreOutlinedIcon from '@mui/icons-material/SettingsBackupRestoreOutlined';
import { Tooltip, IconButton } from '@mui/material';
import React from 'react';

const ResetButton = ({ disabled = false, onClick }) => {
  return (
    <Tooltip title={'Reset to pre-populated forecast number'}>
      <span>
        <IconButton
          size="small"
          disabled={disabled}
          onClick={onClick}
          sx={{
            '&.Mui-disabled': {
              opacity: 0.3,
            },
          }}
        >
          <SettingsBackupRestoreOutlinedIcon fontSize="inherit" />
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default ResetButton;
